module.exports = __webpack_public_path__ + "static/media/inventory.48850845.jpg";